<template>
  <app-layout>
    <template v-slot:header> Comenzi </template>
    <page-section>
      <page-section-body>
        <form class="flex" @submit.prevent="index">
          <div class="sm:w-40 mr-2 ml-0">
            <v-input type="text" v-model="query.email" placeholder="E-mail" />
          </div>
          <div class="sm:w-40 mr-2">
            <v-input
              type="text"
              v-model="query.first_name"
              placeholder="Prenume"
            />
          </div>
          <div class="sm:w-40 mr-2">
            <v-input
              type="text"
              v-model="query.last_name"
              placeholder="Nume familie"
            />
          </div>
          <v-button class="self-end"> Filtreaza </v-button>
        </form>

        <v-card class="mt-2">
          <loader v-if="loading" class="my-5" />
          <template v-else>
            <template v-if="totalRows">
              <orders-index-table :rows="rows" />
              <pagination
                @change:page="changePage($event)"
                :total="meta.total"
                :current_page="meta.current_page"
                :from="meta.from"
                :to="meta.to"
                :next_page_url="links.next"
                :prev_page_url="links.prev"
              />
            </template>
            <no-results v-else class="m-5" />
          </template>
        </v-card>
      </page-section-body>
    </page-section>
  </app-layout>
</template>

<script>
import ordersApi from "../api/resources/ordersApi";

import VCard from "../components/ui/VCard.vue";
import AppLayout from "../layout/AppLayout.vue";
import Loader from "../components/Loader.vue";
import Pagination from "../components/Pagination.vue";
import NoResults from "../components/NoResults.vue";
import OrdersIndexTable from "../components/OrdersIndexTable.vue";
import VInput from "../components/ui/VInput.vue";
import PageSection from "../components/ui/PageSection.vue";
import PageSectionBody from "../components/ui/PageSectionBody.vue";
import VButton from '../components/ui/VButton.vue';

export default {
  components: {
    AppLayout,
    VCard,
    Loader,
    Pagination,
    NoResults,
    OrdersIndexTable,
    VInput,
    PageSection,
    PageSectionBody,
    VButton,
  },

  data() {
    return {
      rows: [],
      meta: {},
      links: {},
      loading: true,
      query: {
        email: "",
        first_name: "",
        last_name: "",
        page: 1,
      },
    };
  },

  computed: {
    totalRows() {
      return this.rows.length;
    },
  },

  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    changePage(page) {
      this.query.page = page;
      this.index();
    },

    index() {
      this.loading = true;
      ordersApi
        .index({ ...this.query })
        .then((data) => {
          this.rows = data.data;
          this.meta = data.meta;
          this.links = data.links;
          this.scrollTop();
          this.loading = false;
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.index();
  },
};
</script>

<style></style>
